







































































import {
    Vue, Component, Prop, Mixins, Watch, 
} from 'vue-property-decorator'
import {Getter, State} from 'vuex-class';


@Component
export default class OtherSelectLine extends Vue {

    @State(state => state.dataMap.commonDictionary) commonDictionary;

    $refs!: {
        select: any,
        specifyDialogRef: any,
        formModelRef: any
    }

    @Prop({default: ''}) value!: any

    @Prop({default: []}) list!: any[]

    @Prop({default: false}) disabled!: any

    @Prop({default: ''}) nameLabel!: any        // name的键名

    @Prop({default: ''}) valueLabel!: any       // value的键名

    @Prop({default: false}) number!: boolean        // other输入框是否只支持数字, 这里指定number的类型

    @Prop({default: ''}) maxlength!: number     // 输入长度限制

    @Prop({default: '60'}) width!: any         // 宽度选择

    @Prop({default: false}) showStatus!: any

    otherValue: string = ''

    dialogVisible: boolean = false

    formModel: any = {
        desc: '',
        status: ''
    }

    oldVal: any = ''

    needCloseFunc: boolean = true

    get rules() {
        return {
            desc: [
                { required: true, message: this.$t1('this_field_is_required'), trigger: 'blur' },
            ],
            status: [
                { required: true, message: this.$t1('this_field_is_required'), trigger: 'blur' },
            ],
        }
    }

    get model() {
        return this.value
    }

    set model(val) {
        this.$emit('input', val)
    }

    mounted() {
        document.body.appendChild(this.$refs.specifyDialogRef.$el)
    }

    @Watch('value', {immediate: true})
    onValueChange(val, oldVal) {
        this.oldVal = oldVal
        if (this.valueLabel) {
            if (!this.list.some(v => v[this.valueLabel] === this.value)) {
                this.otherValue = this.value
            }
        } else if (this.list.indexOf(this.value) === -1) {
            this.otherValue = this.value
        }
    }

    changeValue() {
        this.model = this.otherValue
        this.$refs.select.blur()
    }

    changeSelect(val) {
        if (val === 'Other') {
            this.dialogVisible = true
            this.$nextTick(() => {
                this.$refs.formModelRef.clearValidate()
            })
            return
        }

        this.$emit('changeVal',val)
    }

    handleCancel() {
        this.needCloseFunc = false
        this.$emit('input', this.oldVal)
        this.dialogVisible = false
        setTimeout(()=>{
            this.needCloseFunc = true
        })
    }

    handleClose(){
        if(!this.needCloseFunc) return
        this.$emit('input', this.oldVal)
        this.dialogVisible = false
    }

    handleConfirm() {
        // 如果confirm就阻止handleCancel
        this.needCloseFunc = false
        this.$refs.formModelRef.validate(valid => {
            if (valid) {
                this.$emit('input', this.formModel.desc)
                this.dialogVisible = false
                if (this.showStatus) {
                    this.$emit('status', this.formModel.status)
                }
            }
        })
        setTimeout(()=>{
            this.needCloseFunc = true
        })
    }
}
